// FAQ Functionality
document.addEventListener('DOMContentLoaded', function() {
  const faqItems = document.querySelectorAll('.pf-nst010-faq-item');

  /* Avoid first faq active 
  if (faqItems.length > 0) {
    const firstFaq = faqItems[0];
    const firstPlusImg = firstFaq.querySelector('.plus');
    const firstMinusImg = firstFaq.querySelector('.minus');
    const firstDescription = firstFaq.querySelector('.pf-nst010-description');

    firstDescription.style.display = 'block';
    firstDescription.style.maxHeight = firstDescription.scrollHeight + 'px';
    firstDescription.style.marginTop = '12px';
    firstPlusImg.style.display = 'none';
    firstMinusImg.style.display = 'block';
  }
  */

  faqItems.forEach(function(faqItem) {
    const plusImg = faqItem.querySelector('.plus');
    const minusImg = faqItem.querySelector('.minus');
    const description = faqItem.querySelector('.pf-nst010-description');
    const question = faqItem.querySelector('.pf-nst010-faq-question');

    question.addEventListener('click', function() {
      const isOpen = description.style.maxHeight !== '0px' && description.style.maxHeight !== '';
      
      if (!isOpen) {
        description.style.display = 'block';
        description.style.maxHeight = description.scrollHeight + 'px';
        description.style.marginTop = '12px';
        plusImg.style.display = 'none';
        minusImg.style.display = 'block';
      } else {
        description.style.maxHeight = '0';
        setTimeout(function() {
          description.style.display = 'none';
          description.style.marginTop = '0';
        }, 300);
        plusImg.style.display = 'block';
        minusImg.style.display = 'none';
      }
    });
  });
}); 

const mutationObserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    const notFoundLink = document.querySelector('.aa-NoResultsLink');
    if (notFoundLink) {
      notFoundLink.setAttribute('href', `${window.location.origin}/products`);
      mutationObserver.disconnect(); 
      break;
    }
  }
});

mutationObserver.observe(document.body, {
  childList: true,
  subtree: true
});


function initFakePlaceholder() {
  const wrapper = document.querySelector('.aa-InputWrapper');
  const input = wrapper?.querySelector('.aa-Input');

  if (!wrapper || !input || wrapper.querySelector('.fake-placeholder')) return;

  // Ensure wrapper is relatively positioned
  wrapper.style.position = 'relative';

  // Create the fake placeholder label
  const label = document.createElement('label');
  label.className = 'fake-placeholder';
  label.textContent = 'Search Products';

  // Style it like a placeholder
  Object.assign(label.style, {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#808080',
    pointerEvents: 'none',
    transition: 'opacity 0.2s ease',
    fontSize: getComputedStyle(input).fontSize || '16px',
    opacity: input.value ? '0' : '1',
  });

  // Match font and padding if needed
  label.style.fontFamily = getComputedStyle(input).fontFamily;

  // Insert label into wrapper
  wrapper.appendChild(label);

  // Add event listeners to show/hide fake placeholder
  const toggleLabel = () => {
    label.style.opacity = input.value ? '0' : '1';
  };

  input.addEventListener('input', toggleLabel);
  input.addEventListener('focus', () => label.style.opacity = '0');
  input.addEventListener('blur', toggleLabel);
}

// DOM ready
document.addEventListener('DOMContentLoaded', initFakePlaceholder);

// In case it's dynamically rendered, observe and apply when needed
const observer = new MutationObserver(initFakePlaceholder);
observer.observe(document.body, { childList: true, subtree: true });

// Fallback interval
setInterval(initFakePlaceholder, 500);

// Add to Cart Trigger Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Function to trigger the main add to cart button click
  function triggerMainAddToCart() {
    const mainAddToCartBtn = document.querySelector('.main-product__block-buy_buttons .add-to-cart');
    if (mainAddToCartBtn) {
      mainAddToCartBtn.click();
    }
  }

  // Add click event listeners to our custom buttons
  document.querySelectorAll('.js-add-to-cart-trigger').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      triggerMainAddToCart();
    });
  });
});